@if (user) {
  <div class="container-fluid">
    <div class="row section1">
      <div class="col-12 col-md-7 col-lg-5 col-xl-5">
        <div class="home-details">
          <h5 class="home-title">User Details</h5>
        </div>
      </div>
      <div class="col-12 col-md-5 col-lg-7 col-xl-7">
        <div class="dashboard-btn dashboard-manage">
          <div><a routerLink="/users">
            <button class="btn btn-primary btn-dashboard">Back</button>
          </a></div>
          <div class="d-none"><a (click)="showModal(membershipModal)">
            <button class="btn btn-primary btn-dashboard">Assign membership</button>
          </a></div>
          <div><a [routerLink]="['/users/edit-details/', user.id]">
            <button class="btn btn-primary btn-dashboard">Edit Details</button>
          </a></div>
        </div>
      </div>
    </div>
    @if (!loading) {
      <div class="row section1">
        <div class="col-6 border-right">
          <div class="applicants-details details1 pt-0">
            <div class="row align-items-center">
              <div class="col single-user ">
                <p>Profile Image</p>
              </div>
              <div class="col-auto mb-3">
                <img src="{{user.profile}}" class="rounded-circle" width="100" height="100"
                  onerror="this.src='assets/images/user_avatar.png'" alt="">
                </div>
              </div>
              <hr class="border2">
              <div class="row">
                <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
                  <p>User Id</p>
                </div>
                <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
                  <p>{{user.id}}</p>
                </div>
              </div>
              <hr class="border2">
              <div class="row">
                <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
                  <p>Full Name</p>
                </div>
                <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
                  <p>{{user.firstName + ' ' + user.lastName}}</p>
                </div>
              </div>
              <hr class="border2">
              <div class="row">
                <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
                  <p>Email address</p>
                </div>
                <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
                  <p class="email-display">{{(user.email | lowercaseEmail) || 'NA'}}</p>
                </div>
              </div>
              <hr class="border2">
              @if (!!user.membership?.id) {
                <div class="row">
                  <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
                    <p>Membership</p>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
                    <p>{{user.membership.title || 'NA'}}</p>
                  </div>
                </div>
              }
              <hr class="border2">
              <div  class="row">
                <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
                  <p>Twitter ID</p>
                </div>
                <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
                  <p>{{user.twitterId || 'NA'}}</p>
                </div>
              </div>
              <hr class="border2">
              <div class="row">
                <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
                  <p>Google ID</p>
                </div>
                <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
                  <p>{{user.googleId || 'NA'}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 pt-5">
            <div class="row">
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user">
                <p>Bio</p>
              </div>
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
                <p>{{user.bio || 'NA'}}</p>
              </div>
            </div>
            <hr class="border2">
            <div class="row">
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user">
                <p>Type</p>
              </div>
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
                <p>{{user.type || 'NA'}}</p>
              </div>
            </div>
            <hr class="border2">
            <div class="row">
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
                <p>Registered IP</p>
              </div>
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
                <p>{{user.registeredIP ? user.registeredIP : 'NA'}}</p>
              </div>
            </div>
            <hr class="border2">
            <div class="row">
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
                <p>Created At</p>
              </div>
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
                <p>{{user.createdAt | date : 'medium'}}</p>
              </div>
            </div>
            <hr class="border2">
            <div class="row">
              <div class="col-12 single-user ">
                <p>Social Links</p>
                <div class="col-12">
                  <div class="row">
                    <div class="col">
                      <p>Facebook</p>
                      <hr class="border2">
                      <p>Instagram</p>
                      <hr class="border2">
                      <p>Twitter</p>
                    </div>
                    <div class="col-auto">
                      <p class="text-orange"><a>{{user.facebookLink || 'NA'}}</a></p>
                      <hr class="border2">
                      <p class="text-orange"><a>{{user.instagramLink || 'NA'}}</a></p>
                      <hr class="border2">
                      <p class="text-orange"><a>{{user.twitterLink || 'NA'}}</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      @if (loading) {
        <div>
          <app-user-details-skeletons></app-user-details-skeletons>
        </div>
      }
      <hr class="border2">
      <div class="container-fluid">
        <div class="row section1">
          <div class="col-12 col-md-7 col-lg-5 col-xl-5">
            <div class="home-details">
              <h5 class="home-title">Organizations<span>
              </span></h5>
              <p class="home-subtitle">List of all Organizations</p>
            </div>
          </div>
        </div>
        <div class="row section1">
          <div class="col-12">
            <app-organizations-list [organizations]="organizations"
              [loading]="organizationLoading"
              [organizationPerPage]="organizationPerPage"
              [organizationPage]="organizationPage"
              [organizationTotal]="organizationTotal"
              [modalRef]="modalRef"
              [selectedOrganization]="selectedOrganization"
            ></app-organizations-list>
          </div>
        </div>
      </div>
    </div>
  }

  <ng-template #membershipModal>
    <div class="modal-header">
      <h5 class="modal-title">Assign Membership</h5>
      <button type="button" class="close " data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true" class="">&times;</span>
      </button>
    </div>
    <form class="admin-form" ngNativeValidate (ngSubmit)="handleSubmit()">
      <div class="modal-body">
        <div class="col-md-12 px-3">
          <div class="col-12 p-0 form-group">
            <div class="row ">
              <label>Membership</label>
              <select class="form-control" id="membershipId"
                required
                [(ngModel)]="selectedMembershipId"
                name="membershipId">
              <option selected disabled value="">Select membership</option>
              @for (membership of membershipData; track membership) {
                <option [value]="membership.value">{{membership.label}}</option>
              }
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer justify-content-end ">
      <button type="button" class="btn btn-default" data-dismiss="modal" (click)="modalRef.hide()">Close</button>
      <button type="submit" class="btn btn-primary btn-dashboard" data-dismiss="modal">Save
      </button>
    </div>
  </form>
</ng-template>
